import { render, staticRenderFns } from "./recoverPassword.vue?vue&type=template&id=449cbc4a&scoped=true"
import script from "./recoverPassword.vue?vue&type=script&lang=js"
export * from "./recoverPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449cbc4a",
  null
  
)

export default component.exports